import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/termini")({
  head: () => seoMeta({
    title: "Termini e Condizioni - LexAIPro",
    description: "Termini e Condizioni di utilizzo del servizio LexAIPro fornito da Belead.",
    path: "/termini",
  }),
  component: () => (
    <ContentPage
      eyebrow="Legale"
      title="Termini e Condizioni"
      lead="I presenti Termini regolano l'accesso e l'uso di LexAIPro, servizio fornito da Belead. Utilizzando il servizio, l'utente accetta integralmente questi Termini."
      breadcrumbs={[{ name: "Home", path: "/" }, { name: "Termini", path: "/termini" }]}
      sections={[
        {
          heading: "1. Fornitore del servizio",
          body: "Il servizio LexAIPro è fornito da Belead ('noi', 'Fornitore'). L'utente sottoscrive un contratto direttamente con Belead per l'uso del servizio.",
        },
        {
          heading: "2. Accettazione dei Termini",
          body: "L'accesso, la registrazione o l'uso continuato del servizio costituiscono accettazione integrale e incondizionata dei presenti Termini. Se non si accettano, occorre interrompere l'uso del servizio.",
        },
        {
          heading: "3. Descrizione del servizio",
          body: "LexAIPro è una piattaforma SaaS che fornisce strumenti di intelligenza artificiale per professionisti legali: ricerca normativa e giurisprudenziale, analisi documentale, redazione assistita di atti e contratti.",
        },
        {
          heading: "4. Account e credenziali",
          bullets: [
            "L'utente deve fornire informazioni veritiere, accurate e aggiornate",
            "L'utente è responsabile della riservatezza delle proprie credenziali e di ogni attività svolta tramite il proprio account",
            "L'utente deve avere la maggiore età e, se agisce per un'organizzazione, il potere di vincolarla",
          ],
        },
        {
          heading: "5. Uso accettabile",
          body: "È vietato:",
          bullets: [
            "Ogni uso illecito, fraudolento o lesivo dei diritti altrui",
            "Caricare malware, condurre scansioni o tentare di compromettere la sicurezza del servizio",
            "Effettuare scraping, reverse engineering o aggirare limiti tecnici",
            "Rivendere, ridistribuire o concedere in sublicenza il servizio senza autorizzazione",
            "Generare contenuti illegali, diffamatori, discriminatori o lesivi di diritti di terzi",
            "Violare diritti di proprietà intellettuale di terzi",
          ],
        },
        {
          heading: "6. Intelligenza artificiale - uso responsabile",
          bullets: [
            "L'utente è responsabile dei prompt inseriti e dell'uso degli output, inclusa la verifica della loro accuratezza",
            "Gli output AI possono contenere errori o inesattezze e non sostituiscono il parere professionale qualificato",
            "L'utente garantisce di avere i diritti necessari sui contenuti caricati ed elaborati",
            "Il Fornitore si riserva il diritto di filtrare, rimuovere o limitare contenuti che violino i presenti Termini",
            "Procedura di takedown: i titolari di diritti possono segnalare violazioni a beleadcreativestudio@proton.me; violazioni reiterate comportano la sospensione dell'account",
          ],
        },
        {
          heading: "7. Proprietà intellettuale",
          body: "Il software, il codice sorgente, il design, i marchi, i contenuti editoriali e ogni elemento del servizio sono di proprietà esclusiva di Belead o dei suoi licenzianti. All'utente è concesso un diritto limitato, non esclusivo, non trasferibile e revocabile di utilizzo del servizio nei limiti del piano sottoscritto.",
        },
        {
          heading: "8. Contenuti dell'utente",
          body: "L'utente mantiene la titolarità dei contenuti caricati. Concede a Belead una licenza limitata, gratuita e non esclusiva di ospitare, riprodurre ed elaborare tali contenuti al solo scopo di erogare il servizio.",
        },
        {
          heading: "9. Pagamenti, abbonamenti e fatturazione",
          body: "Pagamenti, abbonamenti, rinnovi, IVA, fatturazione, gestione delle controversie di pagamento e rimborsi sono gestiti dal nostro reseller Paddle, secondo i Buyer Terms di Paddle disponibili su https://www.paddle.com/legal/checkout-buyer-terms. I prezzi e le condizioni di rinnovo sono indicati al momento della sottoscrizione. Salvo diversa indicazione, gli abbonamenti si rinnovano automaticamente al termine di ciascun periodo.",
        },
        {
          heading: "10. Reseller / Merchant of Record",
          body: "Il nostro processo d'ordine è gestito dal nostro reseller online Paddle.com. Paddle.com è il Merchant of Record di tutti gli ordini. Paddle gestisce tutte le richieste di assistenza relative agli ordini e si occupa dei resi e dei rimborsi.",
        },
        {
          heading: "11. Livello di servizio",
          body: "Il servizio è fornito 'così come è' e 'come disponibile'. Pur impegnandoci nella massima continuità, non garantiamo che il servizio sarà ininterrotto, privo di errori o sempre disponibile. Nei limiti di legge, sono escluse tutte le garanzie implicite, inclusa la commerciabilità e l'idoneità a uno scopo specifico.",
        },
        {
          heading: "12. Limitazione di responsabilità",
          body: "Nei limiti consentiti dalla legge, la responsabilità complessiva di Belead nei confronti dell'utente non potrà eccedere l'importo dei corrispettivi pagati nei 12 mesi precedenti l'evento. Sono esclusi i danni indiretti, consequenziali, perdita di profitti, dati o avviamento. Nulla esclude responsabilità per dolo, colpa grave, morte o lesioni personali ove non escludibile per legge.",
        },
        {
          heading: "13. Manleva",
          body: "L'utente manleva e tiene indenne Belead da pretese di terzi derivanti dai contenuti caricati, dall'uso illecito del servizio o dalla violazione dei presenti Termini.",
        },
        {
          heading: "14. Sospensione e risoluzione",
          body: "Belead può sospendere o risolvere l'accesso in caso di: inadempimento contrattuale, mancato pagamento, rischio di sicurezza o frode, violazione reiterata o grave delle policy. In caso di cessazione, l'utente potrà esportare i propri dati entro 30 giorni; successivamente i dati saranno cancellati salvo obblighi di legge.",
        },
        {
          heading: "15. Modifiche ai Termini",
          body: "Belead può aggiornare i presenti Termini. Le modifiche sostanziali saranno comunicate con preavviso ragionevole. L'uso continuato del servizio dopo la decorrenza costituisce accettazione.",
        },
        {
          heading: "16. Legge applicabile e foro competente",
          body: "I presenti Termini sono regolati dalla legge italiana. Per ogni controversia è competente in via esclusiva il foro della sede di Belead, salvo i fori inderogabili previsti dalla normativa consumeristica.",
        },
        {
          heading: "17. Forza maggiore",
          body: "Belead non è responsabile per inadempimenti dovuti a eventi al di fuori del proprio ragionevole controllo, inclusi guasti di rete, atti di autorità, calamità, interruzioni di fornitori terzi.",
        },
      ]}
      heroImage={pickContent(10)}
      updated="Maggio 2026"
    />
  ),
});
